<template>
    <div>
      <!-- 面包屑导航 -->
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
      </el-breadcrumb> -->
      <p class="cor">相同的两个c2c流水id表示撮合的双方</p>
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="用户名">
          <el-input size="small" v-model="formInline.user" placeholder="输入用户"></el-input>
        </el-form-item>
        <el-form-item label="c2c订单id">
          <el-input size="small" v-model="formInline.c2COrderId" placeholder="输入c2c订单id"></el-input>
        </el-form-item>
        <el-form-item label="流水id">
          <el-input size="small" v-model="formInline.c2CBillId" placeholder="输入流水id"></el-input>
        </el-form-item>
        
        <el-form-item label="账单类型">
          <el-select size="small" v-model="formInline.direct" placeholder="请选择">
            <el-option v-for="item in typeToken" :label="item.key" :value="item.value" :key="item.value"></el-option>
          </el-select>
      </el-form-item>
      
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
      <!--列表-->
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <!-- show-summary -->
        <el-table-column align="center" prop="userName" label="用户名" >
        </el-table-column>
        <el-table-column align="center" prop="c2CBillId" label="C2C流水Id" >
        </el-table-column>
        <!-- <el-table-column align="center" prop="matchId" label="执行的撮合" >
        </el-table-column> -->
        <el-table-column align="center" prop="ownC2COrderId" label="C2C订单Id" >
        </el-table-column>
        <el-table-column align="center" prop="oppositeC2COrderId" label="撮合的订单Id" >
        </el-table-column>
        <el-table-column align="center" prop="coinName" label="币种名称" >
        </el-table-column>
        <el-table-column align="center" prop="vol" label="数量" >
        </el-table-column>
        <el-table-column align="center" prop="dealPrice" label="成交价" >
        </el-table-column>
        <!-- <el-table-column align="center" prop="feeVol" label="手续费" >
        </el-table-column>
        <el-table-column align="center" prop="ownUserId" label="自己的" >
        </el-table-column> -->
        <!-- <el-table-column align="center" prop="billType" label="账单类型" >
        </el-table-column> -->
        <el-table-column align="center" label="账单类型" >
          <template slot-scope="scope">
              <p v-if="scope.row.billType == 'buy'">买</p>
              <p v-if="scope.row.billType == 'sell'">卖</p>
              <!-- <p>{{ scope.row.direct == 'buy'?'买':'卖' }}</p> -->
        </template>
        </el-table-column>
        <el-table-column align="center" prop="setupTime" label="结束时间" >
        </el-table-column>
        
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>
  
  <script>
  import { c2cBills } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        // rules表单验证
        formInline: {
          from: 1,
          limit: 10,
          startTime: "",
          endTime: "",
          "c2COrderId": '',
          "c2CBillId":'',
          "user": "",
          "direct": ""
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        timeVal:"",
        typeToken: [
          { key: '请选择', value: '' },
          { key: '买', value: 'buy' },
          { key: '卖', value: 'sell' },
        ],
      }
    },
    // 注册组件
    components: {
      Pagination
    },
  
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取转入列表
      getdata(parameter) {
        this.loading = true
        c2cBills(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              // this.pageparm.currentPage = this.formInline.from
              // this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.pageparm.pageSize = parm.pageSize
        this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.pageparm.currentPage = 1
        this.formInline.from = 1
        console.log(this.timeVal)
        if(this.timeVal instanceof Array){
          this.formInline.startTime = this.timeVal[0]+' 00:00:00'
          this.formInline.endTime = this.timeVal[1]+' 23:59:59'
        }else{
          this.formInline.startTime = ''
          this.formInline.endTime = ''
        }
        this.getdata(this.formInline)
      }
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  .cor{color: rgb(255, 149, 0);}
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/c2c/bills.vue